<template>
  <v-row>
    <v-col
      cols="12"
      xs="12"
      :sm="drawer ? 6 : 12"
      md="6"
      :lg="drawer ? 3 : 6"
      xl="3"
    >
      <resume-item
        title="Total Presupuestado (USD)"
        dotColor="primary"
        propertyName="value"
        :value="agg[0] || { value: 0, doc_count: 0, buckets: [] }"
        before="$ "
        :isLoading="isLoading"
      ></resume-item>
    </v-col>

    <v-col
      cols="12"
      xs="12"
      :sm="drawer ? 6 : 12"
      md="6"
      :lg="drawer ? 3 : 6"
      xl="3"
    >
      <resume-item
        title="Total Ejecutado (USD)"
        dotColor="blue lighten-2"
        propertyName="value"
        :value="agg[1] || { value: 0, doc_count: 0, buckets: [] }"
        format="currency"
        before="$ "
        :isLoading="isLoading"
      ></resume-item>
    </v-col>
    <v-col
      cols="12"
      xs="12"
      :sm="drawer ? 6 : 12"
      md="6"
      :lg="drawer ? 3 : 6"
      xl="3"
    >
      <resume-item
        title="Items Planificados"
        dotColor="primary"
        propertyName="doc_count"
        :value="agg[0] || { value: 0, doc_count: 0, buckets: [] }"
        format="number"
        :decimalPlaces="0"
        :isLoading="isLoading"
      ></resume-item>
    </v-col>
    <v-col
      cols="12"
      xs="12"
      :sm="drawer ? 6 : 12"
      md="6"
      :lg="drawer ? 3 : 6"
      xl="3"
    >
      <resume-item
        title="Items Ejecutados"
        dotColor="blue lighten-2"
        propertyName="doc_count"
        :value="agg[1] || { value: 0, doc_count: 0, buckets: [] }"
        format="number"
        :decimalPlaces="0"
        :isLoading="isLoading"
      ></resume-item>
    </v-col>
  </v-row>
</template>

<script>
import ResumeItem from "@/components/ResumeItem";

export default {
  name: "resume",
  components: {
    ResumeItem
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    agg: {
      type: Array
    }
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    drawer() {
      return !this.$store.getters.dashboardDrawer;
    }
  }
};
</script>

<style></style>
